/* global $ */
import React, { createContext, useEffect, useState, useCallback } from "react";
import Loader from "../Components/Loader";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
dayjs.extend(customParseFormat);
const initialState = {
  loading: false,
  userID: null,
};

export const AuthContextProvider = createContext(initialState);
export const LoaderContext = createContext(initialState);

const AuthContext = ({ children }) => {

  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("userID")
  );

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("userData")) || null
  );
  return (
    <AuthContextProvider.Provider
      value={{

        isAuthenticated,
        setIsAuthenticated,
        user,
        setUser,
      }}
    >
      {children}

    </AuthContextProvider.Provider>
  );
};
const LoaderProvider = ({ children }) => {
  const [fetchedLocation, setLocation] = useState(() => {
    const stored = localStorage.getItem("userLocation");
    return stored ? JSON.parse(stored) : { lat: null, lon: null };
  });
  const [loader, setLoader] = useState(false);
  const [activeCategory, setActiveCategory] = useState('All');
  const [isCartUpdate, setIsCartUpdate] = useState(false)
  const [isLocationUpdate, setIsLocationUpdate] = useState(false);
  const [pujaStatus, setPujaStatus] = useState(null);
  const timezoneOffset = -new Date().getTimezoneOffset() / 60;

  const convertTo12Hour = (timeString) => {
    // Parse with fallback to "HH:mm:ss" format
    const parsed = dayjs(timeString, "H:m:s"); // handles 1-digit hours/mins too
    return parsed.isValid() ? parsed.format("hh:mm A") : "Invalid time";
  };

  useEffect(() => {
    if (fetchedLocation.lat === null || fetchedLocation.lon === null) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const coords = {
              lat: position.coords.latitude,
              lon: position.coords.longitude,
            };
            setLocation(coords);
            localStorage.setItem("userLocation", JSON.stringify(coords));
          },
          (error) => {
            console.error("Error getting location:", error);
            const fallback = { lat: 20.5937, lon: 78.9629 }; // Fallback (India)
            setLocation(fallback);
            localStorage.setItem("userLocation", JSON.stringify(fallback));
          }
        );
      } else {
        console.error("Geolocation not supported.");
      }
    }
  }, [fetchedLocation.lat, fetchedLocation.lon]);
  return (
    <LoaderContext.Provider value={{
      loader, setLoader, activeCategory, convertTo12Hour, pujaStatus, setPujaStatus, setActiveCategory, setIsLocationUpdate, isLocationUpdate, setIsCartUpdate, isCartUpdate, fetchedLocation, timezoneOffset
    }}>
      {children}
      {loader && <Loader />}
    </LoaderContext.Provider>
  );
};
export { LoaderProvider };
export default AuthContext;
